var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.752,
    height: 16.946,
    viewBox: "0 0 17.752 16.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M21.2,10.837a.654.654,0,0,0-.523-.441l-5.345-.778L12.935,4.773a.651.651,0,0,0-1.168,0L9.376,9.617,4.031,10.4A.649.649,0,0,0,3.672,11.5l3.871,3.771L6.63,20.6a.649.649,0,0,0,.943.683l4.779-2.517,4.783,2.513a.626.626,0,0,0,.3.074.647.647,0,0,0,.381-.125.658.658,0,0,0,.259-.636l-.913-5.324,3.871-3.771A.644.644,0,0,0,21.2,10.837ZM16.01,14.582a.644.644,0,0,0-.186.575l.748,4.364L12.65,17.458a.66.66,0,0,0-.605,0L8.122,19.521l.748-4.364a.66.66,0,0,0-.186-.575L5.518,11.49,9.9,10.854a.651.651,0,0,0,.489-.355l1.959-3.974L14.311,10.5a.651.651,0,0,0,.489.355l4.385.636Z",
    transform: "translate(-3.475 -4.41)",
    fill: "#f6c244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8ea6039c640038c2e2be196b0146d9f0.svg";
export { ForwardRef as ReactComponent };